import React, { ChangeEvent, KeyboardEvent, useState } from 'react'
import { searchByPatient } from './constants'

type Props = {
  items: string[]
  onSearch: (param: string) => void
  placeHolder?: string
}

const SelectableMuhidSearch = ({ items, onSearch, placeHolder }: Props) => {
  const [value, setValue] = useState<string>('')
  const [isEditing, setIsEditing] = useState<boolean>(false)
  const [activeIndex, setActiveIndex] = useState<number>(0)

  const handleOnInput = () => {
    setIsEditing(true)
  }

  const handleOnBlur = () => {
    setIsEditing(false)
  }

  const handleOnChange = (ev: ChangeEvent<HTMLInputElement>) => {
    setValue(ev.target.value)
    if (!ev.target.value) {
      onSearch('')
    }
  }

  const handleSelect = () => {
    setActiveIndex(0)
    onSearch(value)
  }

  const handleKeyDown = (ev: KeyboardEvent<HTMLInputElement>) => {
    switch (ev.key) {
      case 'Tab':
        setIsEditing(false)
        setActiveIndex(0)
        onSearch(value)
        ev.preventDefault()
        break
      case 'Enter':
        setIsEditing(false)
        setActiveIndex(0)
        onSearch(value)
        break
    }
  }

  return (
    <div className='selectable-search-wrapper'>
      <input
        placeholder={placeHolder ? placeHolder : searchByPatient}
        className='search-input'
        type='search'
        value={value}
        onBlur={handleOnBlur}
        onInput={handleOnInput}
        onClick={handleOnInput}
        onChange={handleOnChange}
        onKeyDown={handleKeyDown}
      />
      {isEditing && value && (
        <div
          className='options-wrapper'
          role='list' // Add role for accessibility
          aria-label='options' // Add label for accessibility
        >
          {items?.map((i, idx) => (
            <p
              id={i}
              key={i}
              onMouseEnter={() => setActiveIndex(idx)}
              onMouseDown={handleSelect}
              className={`select-option${idx === activeIndex ? ' active' : ''}`}
              role='listitem'
            >
              Search {i} for <span className='select-value'>{value}</span>
            </p>
          ))}
        </div>
      )}
    </div>
  )
}

export default SelectableMuhidSearch
